import { useMediaQuery } from 'react-responsive';

const useIsDesktop = () =>
  useMediaQuery({
    query: '(min-width: 1224px)',
  });

export default useIsDesktop;
